import { DECILE, ReadStudentContext, ReadDIQuery } from '../types'
import { schoolAPContextDist, schoolAPContextAvg } from './highschoolAPContext/schoolAPContext'
import { schoolAPStats, schoolAPStatsPercentage } from './highschoolAPContext/schoolAPStats'

import { nTotalStudents } from './highschoolAPContext/schoolAPContext'

interface CreateAPChartProps {
  apExamYear: string
  distOption: string
  studentsOption: string
  isInteractive: boolean
  apDataCurrent: any
  sortType: string | undefined
}

export const createAPChart = (chartProps: CreateAPChartProps) => {
  const { apExamYear, distOption, studentsOption, isInteractive, apDataCurrent, sortType } =
    chartProps

  let sortedData, readAPContext

  readAPContext = [...apDataCurrent]

  if (sortType) {
    if (sortType.includes('default-order')) sortedData = readAPContext
    else if (sortType.includes('pStudents'))
      sortedData = readAPContext.sort((a, b) => {
        const aPercentage = Math.round((Number(a.nStudents) / nTotalStudents) * 100)
        const bPercentage = Math.round((Number(b.nStudents) / nTotalStudents) * 100)

        if (sortType?.includes('asc')) return aPercentage - bPercentage
        return bPercentage - aPercentage
      })
    else
      sortedData = readAPContext.sort((a, b) => {
        const aCount = Number(a.nStudents)
        const bCount = Number(b.nStudents)

        if (sortType?.includes('asc')) return aCount - bCount
        return bCount - aCount
      })
  } else sortedData = readAPContext

  distOption == 'dist' ? schoolAPContextDist(sortedData) : schoolAPContextAvg(sortedData)
  studentsOption == 'nStudents' ? schoolAPStats(sortedData) : schoolAPStatsPercentage(sortedData)
  // this is for common app, so that we know the very last thing that happens
  // document.getElementById('chart-applicant-id-header').classList.add('waitForLoadD3')
  const div = document.createElement('div')
  div.className = 'waitForLoadD3'
  div.id = 'waitForLoadD3'
  div.innerHTML = ''
  document.body.appendChild(div)
}
